import iphone_13_1 from "../../../images/product/iphone13/than_chi.jpg";
import iphone_13_2 from "../../../images/product/iphone13/trang.jpg";
import iphone_13_3 from "../../../images/product/iphone13/vang.jpg";
import iphone_13_4 from "../../../images/product/iphone13/xanh.jpg";
import iphone_13_normal_1 from "../../../images/product/iphone13/13.jpg";
import iphone_13_normal_2 from "../../../images/product/iphone13/13_trang.jpg";
import iphone_13_normal_3 from "../../../images/product/iphone13/13_128gb_hong.jpg";
import iphone_13_normal_4 from "../../../images/product/iphone13/13_128gb_do.jpg";
import iphone_13pro from "../../../images/product/iphone13/iphone13pro.png";
import iphone_13 from "../../../images/product/iphone13/iphone_13.png";
import iphone_12promax from "../../../images/product/iphone13/iphone-12-pro-max.png";
import iphone_12pro from "../../../images/product/iphone13/iphone-12-pro.png";
import iphone_12 from "../../../images/product/iphone13/iphone-12.png";

import iphone_11 from "../../../images/product/iphone13/iphone-11.png";
import iphone_11_pro from "../../../images/product/iphone13/iphone-11-pro.png";
import iphone_11_pro_max from "../../../images/product/iphone13/iphone-11-pro-max.png";

import iphone_x from "../../../images/product/iphone13/iphone-x.png";
import iphone_xr from "../../../images/product/iphone13/iphone-xr.png";
import iphone_xs_max from "../../../images/product/iphone13/iphone-xs-max.jpg";

import macbook_1 from "../../../images/product/mac/macbook-air-13-inch-m1-8gb-256gb.jpg";
import macbook_2 from "../../../images/product/mac/macbook_2.jpg";
import macbook_3 from "../../../images/product/mac/macbook_2.jpg";
import macbook_4 from "../../../images/product/mac/macbook_2.jpg";
import macbook_5 from "../../../images/product/mac/macbook_2.jpg";
import macbook_6 from "../../../images/product/mac/macbook_2.jpg";
import macbook_7 from "../../../images/product/mac/macbook_2.jpg";

import mac_1 from "../../../images/product/mac/mac_1.jpg";
import mac_2 from "../../../images/product/mac/mac_2.jpg";
import mac_3 from "../../../images/product/mac/mac_3.webp";
import mac_4 from "../../../images/product/mac/mac_4.jpg";
// watch thumnail
import watch1 from "../../../images/product/watch/watch_1.jpg";
import watch2 from "../../../images/product/watch/watch_2.jpg";
import watch3 from "../../../images/product/watch/watch_3.jpg";
import watch4 from "../../../images/product/watch/watch_4.jpg";
// watch
import apple_watch_1 from "../../../images/product/watch/apple_watch_1.jpg";
import apple_watch_2 from "../../../images/product/watch/apple_watch_2.png";
import apple_watch_3 from "../../../images/product/watch/apple_watch_3.png";
import apple_watch_4 from "../../../images/product/watch/apple_watch_4.png";
import apple_watch_5 from "../../../images/product/watch/apple_watch_5.png";
import apple_watch_6 from "../../../images/product/watch/apple_watch_6.png";
import apple_watch_7 from "../../../images/product/watch/apple_watch_7.png";
// ipad
import IPad_1 from "../../../images/product/ipad/IPad_1.png";
import IPad_2 from "../../../images/product/ipad/IPad_2.png";
import IPad_3 from "../../../images/product/ipad/IPad_3.png";
import IPad_4 from "../../../images/product/ipad/IPad_4.png";

import ipad_11 from "../../../images/product/ipad/ipad_11.png";
import ipad_12 from "../../../images/product/ipad/ipad_12.png";
import ipad_13 from "../../../images/product/ipad/ipad_13.png";
import ipad_14 from "../../../images/product/ipad/ipad_14.png";
import ipad_15 from "../../../images/product/ipad/ipad_15.png";

//lk
import lk_1 from "../../../images/product/lk/lk_1.jpg";
import lk_2 from "../../../images/product/lk/lk_2.jpg";
import lk_3 from "../../../images/product/lk/lk_3.jpg";
import lk_4 from "../../../images/product/lk/lk_4.jpg";
import lk_5 from "../../../images/product/lk/lk_5.jpg";
export const dataMenu = [
  {
    id: 1,
    tab: "tab1",
    title: "IPhone",
    data: [
      {
        title: "iPhone 13 Pro Max",
        src: iphone_13pro,
        price: 33490000,
        des: "Thông số kĩ thuật  ",
        id: 1,
        quantityTotal: 5,
        start: 5,
        priceDiscount: 10,
        dataRam: ["128GB", "256GB", "512GB", "1T"],
        dataImg: [
          {
            src: iphone_13_1,
          },
          {
            src: iphone_13_2,
          },
          {
            src: iphone_13_3,
          },
          {
            src: iphone_13_4,
          },
        ],
      },
      {
        title: "iPhone 13 128GB",
        src: iphone_13,
        price: 23000000,
        priceDiscount: 5,
        quantityTotal: 15,
        des: "Thông số kĩ thuật  ",
        id: 2,
        start: 4,
        dataRam: ["128GB", "256GB", "512GB"],
        dataImg: [
          {
            src: iphone_13_normal_1,
          },
          {
            src: iphone_13_normal_2,
          },
          {
            src: iphone_13_normal_3,
          },
          {
            src: iphone_13_normal_4,
          },
        ],
      },
      {
        title: "iPhone 12 Pro Max",
        src: iphone_12promax,
        price: 23000000,
        des: "Thông số kĩ thuật  ",
        id: 3,
        start: 5,
        priceDiscount: 7,
        dataRam: ["128GB", "256GB", "512GB", "1T"],
        dataImg: [
          {
            src: iphone_13_1,
          },
          {
            src: iphone_13_2,
          },
          {
            src: iphone_13_3,
          },
          {
            src: iphone_13_4,
          },
        ],
      },
      {
        title: "iPhone 12 Pro",
        src: iphone_12pro,
        price: 17000000,
        des: "Thông số kĩ thuật  ",
        id: 4,
        start: 5,
        priceDiscount: 3,
        dataRam: ["128GB", "256GB", "512GB", "1T"],
        dataImg: [
          {
            src: iphone_13_1,
          },
          {
            src: iphone_13_2,
          },
          {
            src: iphone_13_3,
          },
          {
            src: iphone_13_4,
          },
        ],
      },
      {
        title: "iPhone 12",
        src: iphone_12,
        price: 15000000,
        des: "Thông số kĩ thuật  ",
        id: 4,
        start: 5,
        priceDiscount: 3,
        dataRam: ["128GB", "256GB", "512GB", "1T"],
        dataImg: [
          {
            src: iphone_13_1,
          },
          {
            src: iphone_13_2,
          },
          {
            src: iphone_13_3,
          },
          {
            src: iphone_13_4,
          },
        ],
      },
      {
        title: "Iphone 11 Pro Max",
        src: iphone_11_pro_max,
        price: 11500000,
        discount: "1400",
        des: "Thông số kĩ thuật  ",
        id: 5,
        start: 3,
        priceDiscount: 3,
        dataRam: ["128GB", "256GB", "512GB", "1T"],
        dataImg: [
          {
            src: iphone_13_1,
          },
          {
            src: iphone_13_2,
          },
          {
            src: iphone_13_3,
          },
          {
            src: iphone_13_4,
          },
        ],
      },
      {
        title: "Iphone 11 Pro",
        src: iphone_11_pro,
        price: 11500000,
        discount: "1400",
        des: "Thông số kĩ thuật  ",
        id: 564646,
        start: 3,
        priceDiscount: 3,
        dataRam: ["128GB", "256GB", "512GB", "1T"],
        dataImg: [
          {
            src: iphone_13_1,
          },
          {
            src: iphone_13_2,
          },
          {
            src: iphone_13_3,
          },
          {
            src: iphone_13_4,
          },
        ],
      },
      {
        title: "Iphone 11 Pro",
        src: iphone_11,
        price: 11500000,
        discount: "1400",
        des: "Thông số kĩ thuật  ",
        id: 568646,
        start: 3,
        priceDiscount: 3,
        dataRam: ["128GB", "256GB", "512GB", "1T"],
        dataImg: [
          {
            src: iphone_13_1,
          },
          {
            src: iphone_13_2,
          },
          {
            src: iphone_13_3,
          },
          {
            src: iphone_13_4,
          },
        ],
      },
      {
        title: "Iphone X",
        src: iphone_x,
        price: 7000000,
        discount: "1400",
        des: "Thông số kĩ thuật  ",
        id: 6,
        start: 1,
      },
      {
        title: "Iphone XR",
        src: iphone_xr,
        price: 6500000,
        discount: "1400",
        des: "Thông số kĩ thuật  ",
        id: 7,
        start: 5,
      },
      {
        title: "Iphone XS Max",
        src: iphone_xs_max,
        price: 8500000,
        discount: "1400",
        des: "Thông số kĩ thuật  ",
        id: 8,
      },
    ],
  },
  {
    id: 2,
    tab: "tab2",
    title: "MacBook",
    data: [
      {
        title: "MacBook Air 13-inch 2020 | M1 8GB/256GB",
        src: macbook_1,
        price: "27990000",
        des: "Thông số kĩ thuật  ",
        id: 1,
        start: 5,
        priceDiscount: 10,
        dataRam: ["128GB", "256GB", "512GB", "1T"],
        dataImg: [
          {
            src: mac_1,
          },
          {
            src: mac_2,
          },
          {
            src: mac_3,
          },
          {
            src: mac_4,
          },
        ],
      },
      {
        title: "Macbook Pro 16 inch 2021 M1 Max 10 CPU - 32 GPU 64GB 8TB 2021",
        src: macbook_2,
        price: "179990000",
        des: "Thông số kĩ thuật  ",
        id: 2,
        start: 5,
        // priceDiscount: 10,
        dataRam: ["8T"],
        dataImg: [
          {
            src: mac_1,
          },
          {
            src: mac_2,
          },
          {
            src: mac_3,
          },
          {
            src: mac_4,
          },
        ],
      },
      {
        title:
          "Macbook Pro 16 inch 2021 M1 Max 10 CPU - 32 GPU 64GB 4TB 2021 | Chính hãng Apple Việt Nam",
        src: macbook_3,
        price: "80000000",
        des: "Thông số kĩ thuật  ",
        id: 3,
        start: 5,
        priceDiscount: 10,
        dataRam: ["4T"],
        dataImg: [
          {
            src: mac_1,
          },
          {
            src: mac_2,
          },
          {
            src: mac_3,
          },
          {
            src: mac_4,
          },
        ],
      },
      {
        title:
          "Macbook Pro M1 Pro 16 10 CPU - 16 GPU 16GB 1TB 2021 | Chính hãng Apple Việt Nam",
        src: macbook_4,
        price: "60000000",
        des: "Thông số kĩ thuật  ",
        id: 4,
        start: 5,
        // priceDiscount: 10,
        dataRam: ["1T"],
        dataImg: [
          {
            src: mac_1,
          },
          {
            src: mac_2,
          },
          {
            src: mac_3,
          },
          {
            src: mac_4,
          },
        ],
      },
      {
        title:
          "Apple Macbook Pro 13 Touch Bar i5 1.4 512GB 2020 I Chính hãng Apple Việt Nam ",
        src: macbook_5,
        price: "40000000",
        des: "Thông số kĩ thuật  ",
        id: 5,
        start: 5,
        priceDiscount: 30,
        dataRam: ["128GB", "256GB", "512GB", "1T"],
        dataImg: [
          {
            src: mac_1,
          },
          {
            src: mac_2,
          },
          {
            src: mac_3,
          },
          {
            src: mac_4,
          },
        ],
      },
      {
        title:
          "Apple Macbook Pro 16 Touch Bar I7 2.6 16GB 512GB 2019 Bạc Chính Hãng (MVVL2)",
        src: macbook_6,
        price: "55000000",
        des: "Thông số kĩ thuật  ",
        id: 6,
        start: 5,
        priceDiscount: 10,
        dataRam: ["512GB"],
        dataImg: [
          {
            src: mac_1,
          },
          {
            src: mac_2,
          },
          {
            src: mac_3,
          },
          {
            src: mac_4,
          },
        ],
      },
      {
        title: "Macbook Pro 14 inch 2021 | Chính hãng Apple Việt Nam",
        src: macbook_7,
        price: "52000000",
        des: "Thông số kĩ thuật  ",
        id: 7,
        start: 5,
        priceDiscount: 17,
        dataRam: ["128GB", "256GB", "512GB", "1T"],
        dataImg: [
          {
            src: mac_1,
          },
          {
            src: mac_2,
          },
          {
            src: mac_3,
          },
          {
            src: mac_4,
          },
        ],
      },
    ],
  },
  {
    id: 3,
    tab: "tab3",
    title: "Apple Watch",
    data: [
      {
        title:
          "Apple Watch Series 6 (GPS) 40mm - Viền nhôm dây cao su - Chính hãng VN/A",
        src: apple_watch_1,
        price: 33490000,
        des: "Thông số kĩ thuật  ",
        id: 1,
        start: 5,
        priceDiscount: 10,
        dataRam: ["40mm", "44mm"],
        dataImg: [
          {
            src: watch1,
          },
          {
            src: watch2,
          },
          {
            src: watch3,
          },
          {
            src: watch4,
          },
        ],
      },
      {
        title:
          "Apple Watch Series 6 (GPS) 44mm - Viền nhôm dây cao su - Chính hãng VN/A",
        src: apple_watch_2,
        price: 33490000,
        des: "Thông số kĩ thuật  ",
        id: 2,
        start: 5,
        priceDiscount: 10,
        dataRam: ["40mm", "44mm"],
        dataImg: [
          {
            src: watch1,
          },
          {
            src: watch2,
          },
          {
            src: watch3,
          },
          {
            src: watch4,
          },
        ],
      },
      {
        title:
          "Apple Watch Series 7 4G, 41mm -  Viền nhôm dây cao su - Chính hãng VN/A ",
        src: apple_watch_3,
        price: 13000000,
        des: "Thông số kĩ thuật  ",
        id: 3,
        start: 4,
        priceDiscount: 2,
        dataRam: ["40mm", "44mm"],
        dataImg: [
          {
            src: watch1,
          },
          {
            src: watch2,
          },
          {
            src: watch3,
          },
          {
            src: watch4,
          },
        ],
      },
      {
        title: "Apple Watch Series 3 GPS 38mm - Chính hãng VN/A",
        src: apple_watch_4,
        price: 5000000,
        des: "Thông số kĩ thuật  ",
        id: 4,
        start: 5,
        priceDiscount: 15,
        dataRam: ["40mm", "44mm"],
        dataImg: [
          {
            src: watch1,
          },
          {
            src: watch2,
          },
          {
            src: watch3,
          },
          {
            src: watch4,
          },
        ],
      },
      {
        title:
          "Apple Watch SE (GPS) 44mm - Viền nhôm dây cao su - Chính hãng VN/A",
        src: apple_watch_5,
        price: 8000000,
        des: "Thông số kĩ thuật  ",
        id: 5,
        start: 3,
        priceDiscount: 8,
        dataRam: ["40mm", "44mm"],
        dataImg: [
          {
            src: watch1,
          },
          {
            src: watch2,
          },
          {
            src: watch3,
          },
          {
            src: watch4,
          },
        ],
      },
      {
        title:
          "Apple Watch Series 6 (4G) 40mm - Viền nhôm dây cao su - Chính hãng VN/A",
        src: apple_watch_6,
        price: 11000000,
        des: "Thông số kĩ thuật  ",
        id: 6,
        start: 5,
        priceDiscount: 10,
        dataRam: ["40mm", "44mm"],
        dataImg: [
          {
            src: watch1,
          },
          {
            src: watch2,
          },
          {
            src: watch3,
          },
          {
            src: watch4,
          },
        ],
      },
      {
        title:
          "Apple Watch SE (4G) 44mm - Viền nhôm dây cao su - Chính hãng VN/A",
        src: apple_watch_7,
        price: 8800000,
        des: "Thông số kĩ thuật  ",
        id: 7,
        start: 5,
        priceDiscount: 2,
        dataRam: ["40mm", "44mm"],
        dataImg: [
          {
            src: watch1,
          },
          {
            src: watch2,
          },
          {
            src: watch3,
          },
          {
            src: watch4,
          },
        ],
      },
    ],
  },

  {
    id: 4,
    tab: "tab4",
    title: "IPad",
    data: [
      {
        title:
          "Apple iPad Air 10.9 - 2020 - Wifi - 64GB - Chính Hãng Apple Việt Nam",
        src: ipad_11,
        price: 33490000,
        discount: "35000000",
        des: "Thông số kĩ thuật  ",
        id: 1,
        start: 5,
        // priceDiscount: 1,
        dataRam: ["128GB", "256GB", "512GB"],
        dataImg: [
          {
            src: IPad_1,
          },
          {
            src: IPad_2,
          },
          {
            src: IPad_3,
          },
          {
            src: IPad_4,
          },
        ],
      },
      {
        title:
          "Apple iPad Mini 6 - 8.3 - (2021) - Wifi - 256GB - Chính Hãng Apple VN",
        src: ipad_12,
        price: 17000000,
        des: "Thông số kĩ thuật  ",
        id: 2,
        priceDiscount: 1,
        start: 5,
        dataRam: ["128GB", "256GB", "512GB"],
        dataImg: [
          {
            src: IPad_1,
          },
          {
            src: IPad_2,
          },
          {
            src: IPad_3,
          },
          {
            src: IPad_4,
          },
        ],
      },
      {
        title:
          "Apple iPad Mini 6 - 8.3 - (2021) - Wifi - 64GB - Chính Hãng Apple VN",
        src: ipad_13,
        price: 1349000,
        des: "Thông số kĩ thuật  ",
        id: 3,
        // priceDiscount: 1,
        start: 5,
        dataRam: ["128GB", "256GB", "512GB"],
        dataImg: [
          {
            src: IPad_1,
          },
          {
            src: IPad_2,
          },
          {
            src: IPad_3,
          },
          {
            src: IPad_4,
          },
        ],
      },
      {
        title:
          "Apple iPad Mini 6 - 8.3 - (2021) - Wifi - 64GB - Chính Hãng Apple VN",
        src: ipad_14,
        price: 1949000,
        des: "Thông số kĩ thuật  ",
        id: 4,
        priceDiscount: 20,
        start: 5,
        dataRam: ["128GB", "256GB", "512GB"],
        dataImg: [
          {
            src: IPad_1,
          },
          {
            src: IPad_2,
          },
          {
            src: IPad_3,
          },
          {
            src: IPad_4,
          },
        ],
      },
      {
        title:
          "Apple iPad Pro M1 11 - (2021) - Wifi+5G - 512GB - Chính hãng Apple VN",
        src: ipad_15,
        price: 32000000,
        des: "Thông số kĩ thuật  ",
        id: 5,
        priceDiscount: 5,
        start: 5,
        dataRam: ["128GB", "256GB", "512GB"],
        dataImg: [
          {
            src: IPad_1,
          },
          {
            src: IPad_2,
          },
          {
            src: IPad_3,
          },
          {
            src: IPad_4,
          },
        ],
      },
    ],
  },
  {
    id: 5,
    tab: "tab5",
    title: "Linh Kiện",
    data: [
      {
        title: "Tai nghe Bluetooth Apple AirPods 2 VN/A",
        src: lk_1,
        price: 3190000,
        priceDiscount: 50,
        des: "Thông số kĩ thuật  ",
        id: 1,
      },
      {
        title:
          "Sạc nhanh Apple iPhone 20W Type-C PD MHJE3ZA | Chính hãng Apple Việt Nam",
        src: lk_2,
        price: "570000",

        des: "Thông số kĩ thuật  ",
        id: 2,
      },
      {
        title:
          "Tai nghe chụp tai chống ồn Apple AirPods Max | Chính hãng Apple Việt Nam",
        src: lk_3,
        priceDiscount: 19,
        price: "1050000",
        des: "Thông số kĩ thuật  ",
        id: 3,
      },
      {
        title: "Chuột Apple Magic Mouse 2 | Chính hãng Apple Việt Nam",
        src: lk_4,
        price: "2400000",
        des: "Thông số kĩ thuật  ",
        id: 4,
      },
      {
        title:
          "Bàn phím Apple Magic Keyboard + Touch ID 2021 MK293 | Chính hãng Apple Việt Nam",
        src: lk_5,
        priceDiscount: 5,
        price: "3500000",
        des: "Thông số kĩ thuật  ",
        id: 5,
      },
    ],
  },
];
export const dataSortPrice = [
  {
    label: "Tất cả",
    value: 1,
  },
  {
    label: "Từ thấp đến cao ",
    value: 2,
  },
  {
    label: "Từ cao đến thấp",
    value: 3,
  },
];
export const dataSortname = [
  {
    label: "Tất cả",
    value: 1,
  },
  {
    label: "Dưới 10 triệu",
    value: 2,
  },
  {
    label: "Từ 10 đến 15 triệu",
    value: 3,
  },
  {
    label: "Từ 15 đến 20 triệu",
    value: 4,
  },
  {
    label: "Từ 20 đến 25 triệu",
    value: 5,
  },
  {
    label: "Trên 25 triệu",
    value: 6,
  },
];
